<script>
export default {
  name: "ClearLayout",
};
</script>

<template>
  <RouterView />
</template>
